<template>
  <div>
    <v-row v-for="(item, i) in aboutSponsor" :key="i">
      <v-col>
        <div class="vhtml" v-html="item[`description_${lang}`]"></div>
        <GreenButton
                class="mt-6"
                label="Download sponsor package"
                v-if="item.uploaded_file"
                @onPress="downloadFile(item.uploaded_file)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import GreenButton from "../buttons/GreenButton";
  import { url } from "../../util/Constants";

  export default {
    components: {
      GreenButton
    },
    computed: {
      ...mapState({
        aboutSponsor: state => state.About.sponsor,
        lang: state => state.Branch.lang
      })
    },
    methods: {
      downloadFile(path) {
        if (path) {
          window.open(url + path);
        }
      }
    }
  };
</script>

<style>
</style>
